export default __webpack_public_path__ + "static/media/lion_HAPPY.b53d4214.png";